import {
  MESSAGE_LISTE_SUCCES,
  MESSAGE_LISTE_ECHEC,
  MESSAGE_LISTE_RESET,
  MESSAGE_LISTE_REQUETTE,
  MESSAGE_CREE_REQUETTE,
  MESSAGE_CREE_SUCCES,
  MESSAGE_CREE_ECHEC,
} from "../constantes/messageConstantes";
export const messageListeReducer = (
  state = { msg: [], loading: false },
  action
) => {
  switch (action.type) {
    case MESSAGE_LISTE_REQUETTE:
      return {
        loading: true,
      };
    case MESSAGE_LISTE_SUCCES:
      return { msg: action.payload, loading: false };
    case MESSAGE_LISTE_ECHEC:
      return { erreur: action.payload, loading: false };
    case MESSAGE_LISTE_RESET:
      return { msg: [], loading: false };
    default:
      return state;
  }
};
export const messageCreeReducer = (state = { message: {} }, action) => {
  switch (action.type) {
    case MESSAGE_CREE_REQUETTE:
      return { loading: true };
    case MESSAGE_CREE_SUCCES:
      return { loading: false, message: action.payload };
    case MESSAGE_CREE_ECHEC:
      return { loading: false, erreur: action.payload };

    default:
      return state;
  }
};
